export default "__VITE_ASSET__5db5b7c1__"